<template>
    <div class="serverDetails">
        <Row>
            <i-col span="8">
                <!-- 基本信息 -->
                <div style="border-bottom: none;padding-bottom: 0px;"
                     class="card mar-r10">
                    <div style="margin-bottom: 15px;"
                         class="config-item-title">{{$t('基本信息')}}</div>
                    <div class="card-info-overview">
                        <div class="cio-top">
                            <div class="col-title">
                                <img v-if="baseInfo.osCategory && baseInfo.osCategory.toLowerCase() === 'linux'"
                                     src="@/assets/images/console/servicedetails/linux.png"
                                     alt="">
                                <img v-if="baseInfo.osCategory && baseInfo.osCategory.toLowerCase() === 'windows'"
                                     src="@/assets/images/console/servicedetails/windows.png"
                                     alt="">
                                <img v-if="baseInfo.osCategory && baseInfo.osCategory.toLowerCase() === 'aix'"
                                     src="@/assets/images/console/servicedetails/aix.png"
                                     alt="">
                                <img v-if="!baseInfo.osCategory"
                                     src="@/assets/images/console/servicedetails/noneos.png"
                                     alt="">
                            </div>
                            <p>{{$i18n.t(baseInfo.statusName)}}</p>
                            <div class="status-btn"
                                 @click="() => baseInfo.status == 'running' && (baseInfo.manageStatus == 'ununited' || baseInfo.manageStatus == 'disconnect' || baseInfo.manageStatus === 'connected') && baseInfo.status !== 'deleted' && baseInfo.lockStatus !== 'locked' && !isNoPer({
                                  click: 'access'
                              }) && retryConnectHost()">
                                <span :class="judgeInstanceStatusIcon()">
                                    <i :class="{'icon-link-o':baseInfo.manageStatus =='connected','icon-unlink-o':baseInfo.manageStatus!='connected'}"></i>
                                    {{$i18n.t(baseInfo.manageStatusName)}}
                                </span>
                                <span class="el-can-click"
                                      v-if="baseInfo.status == 'running' && (baseInfo.manageStatus == 'ununited' || baseInfo.manageStatus == 'disconnect' || baseInfo.manageStatus === 'connected') && baseInfo.status !== 'deleted' && baseInfo.lockStatus !== 'locked' && !isNoPer({
                                  click: 'access'
                              })">
                                    {{$i18n.t(baseInfo.manageStatusName)}}
                                </span>
                                <span v-if="!(baseInfo.status == 'running' && (baseInfo.manageStatus == 'ununited' || baseInfo.manageStatus == 'disconnect' || baseInfo.manageStatus === 'connected') && baseInfo.status !== 'deleted' && baseInfo.lockStatus !== 'locked' || isNoPer({
                                  click: 'access'
                              }))">{{$i18n.t(baseInfo.manageStatusName)}}</span>
                            </div>
                        </div>
                        <div class="cio-bottom">
                            <p v-for="(item, index) in selfFormList"
                               :key="index"
                               class="cio-dsc">
                                <span class="col-title">
                                    {{$t(item.name)}}:</span>
                                <span class="col-content">
                                    <span v-if="item.key === 'instanceChargeTypeName'">
                                        {{baseInfo.instanceChargeTypeName ? baseInfo.instanceChargeTypeName : (baseInfo.cloudEnvType === 'Aws' ? '按量计费' : '--')}}
                                    </span>
                                    <span v-else-if="item.key === 'tagNames'">
                                        <Tag class="tag-item"
                                             v-for="(child, index) in getTagInfo()"
                                             v-if="index < 2"
                                             :key="index"
                                             style="margin-left:10px;"
                                             :color="child.rgbCode||'#9F9BB7'">
                                            {{child.tagName}} {{child.tagValue && child.tagValue.trim() ? ':'+child.tagValue : ''}}
                                        </Tag>
                                        <!--更多标签-->
                                        <Tag class="icon-more-tag"
                                             :style="getTagInfo().length>2 ? 'display: inline-block;' : 'display: none;'">
                                            <span class="icon-more-1-o"
                                                  title="更多"
                                                  @click="() => showBindWindow()"></span>
                                        </Tag>
                                        <span style="fontSize:16px;"
                                              class="ivu-icon ivu-icon-ios-add-circle-outline"
                                              @click="() => showBindWindow()"></span>
                                    </span>
                                    <span v-else>{{baseInfo[item.key] || '--'}}</span>
                                </span>
                            </p>
                        </div>
                    </div>

                    <!-- <Tooltip class="config-tooltip"
                             theme="light">
                        <i @click="editConfigInfo"
                           class="icon-edit-1-o title-icon"
                           :class="{
                            'disabledA': isLocak || isNoPer({
                                click: 'edit'
                            })||baseInfo.status==='creating'
                        }"></i>
                        <div slot="content">
                            {{$t('对平台所记录的实例IP地址、创建时间、到期时间、备注信息进行更新，对于不同云环境更新信息将会不同。')}}
                        </div>
                    </Tooltip> -->
                </div>
                <!-- 配置信息 -->
                <div style="border-top: none;"
                     class="card mar-r10 config">
                    <div v-for="(cd, index) in configData"
                         :key="index"
                         class="config-item">
                        <div class="config-item-title">{{$t(cd.name)}}</div>
                        <div class="content">
                            <p v-for="(item, key) in cd.children"
                               :key="key">
                                <span class="col-title">
                                    {{$t(item.name)}}:</span>
                                <span class="col-content">
                                    <span>
                                        <span v-if="!['network','tagNames','isG','instanceTypeName','securityGroupName','cloudEnvName', 'remoteLoginType', 'loginInfo', 'serverType'].includes(item.key)"
                                              :title="item.value || '--'"
                                              :class="{
                            'router-span': item.value !== '--' && item.value && item.router && !isGoPer(item)
                        }"
                                              :style="{'word-break': item.key === 'description' ? 'break-all' : 'break-word'}">{{item.value || '--'}}</span>
                                        <!-- <span v-if="item.key === 'instanceId'">
                                        <i class="copy-icon icon-ram-2-o"></i>
                                    </span> -->
                                        <span style="cursor: pointer;"
                                              v-if="item.key === 'instanceId'"
                                              @click="copylink">
                                            <i style="font-size: 16px;"
                                               class="icon-log-o"></i>
                                            <input ref="copyrelay"
                                                   :value="item.value || '--'"
                                                   class="copy-el" /></span>
                                    </span>
                                    <template v-if="item.key === 'network'">
                                        <div v-if="item.value"
                                             class="groupWrap">
                                            <div v-for="el in item.value"
                                                 class="groupItem"
                                                 :key="el.resourceId">
                                                <span :title="`${el.vpcName}/${el.subnetName}`"
                                                      class="textVpcElli">{{el.vpcName}}</span>
                                                <span :title="`${el.vpcName}/${el.subnetName}`"
                                                      class="textVpcElli">/{{el.subnetName}}</span>
                                            </div>
                                        </div>
                                        <span v-else>--/--</span>
                                    </template>
                                    <span v-if="item.key === 'tagNames'">
                                        <Tag class="tag-item"
                                             v-for="(child, index) in item.value"
                                             :key="index"
                                             style="margin-left:10px;"
                                             :color="child.rgbCode||'#9F9BB7'">{{child.tagName+':'+child.tagValue || child}}</Tag>
                                        <span style="fontSize:16px;"
                                              class="ivu-icon ivu-icon-ios-add-circle-outline"
                                              @click="() => showBindWindow()"></span>
                                    </span>
                                    <span v-if="item.key === 'isG'">
                                        <span>
                                            {{!baseInfo.originParam ? $t('否') : $t('是')}}
                                        </span>
                                    </span>
                                    <span v-if="item.key === 'instanceTypeName'">
                                        <span :title="getInstanceTypeInfo()">
                                            {{getInstanceTypeInfo()}}
                                        </span>
                                    </span>
                                    <template v-if="item.key === 'securityGroupName'">
                                        <div v-if="item.value"
                                             class="groupWrap">
                                            <div v-for="(el, i) in item.value"
                                                 class="groupItem textWrap"
                                                 :title="el.sgName"
                                                 :key="el.resourceId">{{el.sgName}}
                                                <span v-if="item.value && i < item.value.length - 1">，</span>
                                            </div>
                                        </div>
                                        <span v-else>--</span>
                                    </template>
                                    <span v-if="item.key === 'cloudEnvName'"
                                          style="width: 100%;display: inline-block;"
                                          class="rc-ellipsis">
                                        <i style="vertical-align: middle;"
                                           :class="envIcon(baseInfo.cloudEnvType)"></i>
                                        <span style="vertical-align: middle;margin-left: -15px;">{{item.value}}</span>
                                    </span>
                                    <span v-if="item.key === 'remoteLoginType'"
                                          class="rc-ellipsis">
                                        <span>{{{ 'ByPassword': $t('密码'), 'ByKeypair': $t('密钥') }[baseInfo[item.key]]|| '--'}}</span>
                                    </span>
                                    <span v-if="item.key === 'remoteLoginType'"
                                          class="rc-ellipsis">
                                        （
                                        <span :title="`${baseInfo.managementAccount || '--'}/${getPassword() || '--'}`"
                                              style="max-width:180px;display: inline-block;position: relative; white-space: normal;word-break: break-all; vertical-align: middle">{{`${baseInfo.managementAccount || '--'}/${getPassword() || '--'}`}}</span>
                                        <i class="eye-i"
                                           v-if="item.key === 'remoteLoginType' && ((baseInfo.remoteLoginType === 'ByKeypair' && baseInfo.keypairName) || (baseInfo.remoteLoginType === 'ByPassword' && baseInfo.managemenPassword))"
                                           @click="changeIsPassStatus"
                                           :class="{true:'icon-open-up-o',false:'icon-close-1-o'}[isPass]"></i>）
                                    </span>
                                    <span v-if="item.key === 'serverType'"
                                          class="rc-ellipsis"
                                          style="display: flex;align-items: center;">
                                        <div :class="{
                                                    'server-type-div': true,
                                                    'instance-server-type': item.value === 'instance',
                                                    'server-server-type': item.value === 'server',
                                                    'server-instance-server-type': item.value === 'serverInstance',
                                                    'elastic-instance-server-type': item.value === 'elasticInstance'
                                                }"
                                             style="text-style:center"
                                             :title="{
                                'instance': $t('实例'),
                                'server': $t('服务器'),
                                'serverInstance': $t('服务器实例'),
                                'elasticInstance': $t('弹性伸缩实例')
                            }[item.value]">{{{ 'instance': 'In', 'server': 'S', 'serverInstance': 'SI', 'elasticInstance': 'EI' }[item.value]}}
                                        </div>
                                        <span style="margin-left: 8px;">{{{ 'instance': $t('实例'), 'server': $t('服务器'), 'serverInstance': $t('服务器实例'), 'elasticInstance': $t('弹性伸缩实例') }[item.value]}}
                                        </span>
                                        <Tooltip style="margin-left: 5px;"
                                                 :transfer="true"
                                                 theme='light'>
                                            <i style="font-size:14px;position:relative;top:2px;"
                                               class="icon-prompt-1-o"></i>
                                            <div slot="content">
                                                <p>S(服务器)：已配置服务器信息的等待创建的主机</p>
                                                <p>In(实例)：通过镜像直接创建的主机</p>
                                                <p>SI(服务器实例)：通过服务器模板创建的主机</p>
                                                <p>EI(弹性伸缩实例)：通过弹性伸缩组自动伸缩创建的主机</p>
                                            </div>
                                        </Tooltip>
                                    </span>
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </i-col>
            <i-col span="16">
                <div style="padding: 7.5px 15px;"
                     class="card mar-b10">
                    <Row>
                        <Col v-for="(item, index) in configOverview"
                             v-if="item.envShow.includes('All') || item.envShow.includes(baseInfo.cloudEnvType)"
                             :key="index"
                             style="padding: 7.5px;"
                             class="overview-item"
                             :class="{'no-border-bottom': tabShowIndex < 5}"
                             span="6">
                        <div class="overview-card"
                             :class="{'card-disabled': !item.show}">
                            <div style="cursor: pointer;"
                                 class="left-icon"
                                 @click="overviewClick(item)">
                                <i :style="`color:${item.iconColor}`"
                                   :class="item.icon"></i>
                            </div>
                            <div class="info">
                                <p style="font-size: 16px;"
                                   @click="overviewClick(item)">{{tabNums[item.key] || 0}}</p>
                                <p @click="overviewClick(item)">{{$i18n.t(item.name)}} </p>
                            </div>
                        </div>
                        </Col>
                    </Row>
                </div>
                <!-- 监控信息 -->
                <div style="border-bottom: none;"
                     v-if="baseInfo.serverType !== 'server'"
                     class="card">
                    <div class="card-title">
                        {{$i18n.t('监控信息')}}
                    </div>
                    <monitordetail :data="baseInfo"
                                   @goto="gotoMonitor"
                                   ref="monitorDetail"
                                   v-if="baseInfo.serverType !== 'server'"></monitordetail>
                </div>
                <!-- 告警信息 -->
                <div style="border-top: none;"
                     class="card">
                    <div class="card-title">
                        {{$i18n.t('告警信息')}}
                    </div>
                    <alarmInfo style="height: 343px;overflow-y: auto;"
                               :quote="'hostdetail'"
                               :isNoPer="isNoPer"
                               :isLocak="isLocak"></alarmInfo>
                </div>
                <!-- 告警规则 -->
                <div v-if="!$store.state.app.isAdvanced"
                     style="padding-bottom: 0px;"
                     class="card">
                    <div class="card-title">
                        {{$i18n.t('告警规则')}}
                    </div>
                    <alarmRule ref="alarm"
                               :id="baseInfo.id"
                               :isNoPer="isNoPer"
                               :nowRow="baseInfo"
                               :isLocak="isLocak"></alarmRule>
                </div>
            </i-col>
        </Row>
        <!-- <configInfoModal ref="configInfoModal"
                         :newdata="baseInfo" /> -->
        <!-- <accessInstance ref="accessInstance"
                        :data="baseInfo"
                        @back="gotoDetail" />
        <bindTags ref="bindTags"
                  @refresh="reload"></bindTags>
        <instanceoper ref="instanceoper"
                      :data="[baseInfo]"
                      :entry="'detail'"
                      v-if="!isNoPer({
                            click: 'addalarm'
                        }) && !isLocak"
                      type="addalarm"
                      :nowRow="[baseInfo]"
                      :objType="'host'"
                      :choosedOne="[baseInfo]"
                      :addTagType="'one'"
                      :autoSubmit="true"
                      @refresh="refreshAlarm" /> -->
    </div>
</template>

<script>
import { mgtConstant } from '@/service/constant'
import alarmInfo from '../monitoralarm/alarmInfo'
import alarmRule from '../monitoralarm/alarmRule'
// import configInfoModal from './configInfoModal'
// import oper from '@/views/components/biz/envinstance/oper'
import monitordetail from './monitordetail'
// import accessInstance from '@/views/components/biz/envinstance/accessInstance'
// import instanceoper from '@/views/components/biz/envinstance/instanceoper/instanceoper'
import API from '@/service/api'
export default {
    name: 'serverDetails',
    props: ['isLocak', 'baseInfo', 'isNoPer', 'data'],
    components: {
        // configInfoModal,
        // accessInstance,
        monitordetail,
        alarmInfo,
        alarmRule
        // tagChoose,
        // bindTags,
        // instanceoper
    },
    data () {
        return {
            selfFormList: [
                {
                    key: 'osCategory',
                    name: '操作系统'
                },
                {
                    key: 'instanceChargeTypeName',
                    name: '计费方式'
                },
                {
                    key: 'tagNames',
                    name: '标签'
                }
            ],
            configOverview: mgtConstant.configOverview,
            isPass: false,
            mAndDStatus: {
                none: {
                    color: '#b3b3b3',
                    name: '未安装',
                    disabled: `${this.baseInfo.manageStatus !== 'connected' || this.baseInfo.manageStatus === 'disconnect' || this.baseInfo.lockStatus === 'locked' || this.baseInfo.status === 'deleted'}`
                },
                running: {
                    color: '#2ecc71',
                    name: '运行中'
                },
                failure: {
                    color: '#ef4235',
                    name: '异常',
                    disabled: `${this.baseInfo.manageStatus === 'disconnect' || this.baseInfo.status === 'deleted'}`
                },
                installing: {
                    color: '#ffc000',
                    name: '安装中'
                },
                pending: {
                    color: '#ffc000',
                    name: '安装中'
                }
            },
            configData: mgtConstant.hostsInfoMap,
            allTags: [],
            tabShowIndex: 0,
            tabNums: {}
        }
    },
    watch: {
        baseInfo () {
            this.getConfigInfo()
            this.init()
        }
    },
    computed: {
        isPublic () {
            return this.baseInfo.cloudEnvType && mgtConstant.isInsFamilyProp.indexOf(this.baseInfo.cloudEnvType) > -1
        }
    },
    mounted () {
        this.getConfigInfo()
        this.init()
    },
    methods: {
        // 卸载监控组件
        uninstallAgent () {
            const result = []
            result.push(this.baseInfo)
            // oper.invoke(this, 'uninstall', result)
        },
        // 获取实例类型名称，公有云需要展示类型族
        getInstanceTypeInfo () {
            if (this.isPublic) {
                if (this.baseInfo.instanceTypeName) {
                    return `${this.baseInfo.instanceTypeFamilyName ? `${this.baseInfo.instanceTypeFamilyName}[${this.baseInfo.instanceTypeName}]` : this.baseInfo.instanceTypeName}`
                }
                return '--'
            }
            return this.baseInfo.instanceTypeName || '--'
        },
        getHostStatus (key) {
            return (key === 'dockerStatus' || key === 'monitorStatus') && this.baseInfo[key] && this.mAndDStatus[this.baseInfo[key]].disabled
        },
        init () {
            const result = mgtConstant.initHostTabData(this.baseInfo)
            let index = 0
            this.configOverview.forEach(item => {
                item.show = true
                if (item.key === 'harddisk') {
                    item.show = result[item.key].show
                }
                if (item.key === 'logNum') {
                    item.show = result.log.show
                }
                if (item.key === 'intsnapshotNum') {
                    item.show = result.intsnapshot.show
                }
                if (item.key === 'taskNum') {
                    item.show = result.task.show
                }
                if (item.key === 'scriptNum') {
                    item.show = false // result.scriptdetail.show
                }
                if (item.key === 'historyStatus') {
                    item.show = result.history.show
                }
                if (item.key === 'securityGroupNum') {
                    item.show = result.securityGroup.show
                }
                if (item.key === 'paramConfigNum') {
                    item.show = false // result.paramConfig.show
                }
                index = item.show ? index + 1 : index
            })
            this.configOverview = JSON.parse(JSON.stringify(this.configOverview))
            this.tabShowIndex = index
            this.initTabNum()
        },
        initTabNum () {
            // 获取硬盘
            this.axios.get(this.urlFormat(API.GET_HOST_STORAGE, true, [this.baseInfo.id]), {
                params: {
                    envId: this.baseInfo.cloudEnvId,
                    notFailure: 'failure'
                }
            }).then(res => {
                this.$set(this.tabNums, 'harddisk', res ? res.length : 0)
            })
            // 获取快照
            this.axios.get(this.urlFormat(API.SNAPSHOTS, true), {
                params: {
                    cloudEnvId: this.baseInfo.cloudEnvId,
                    resVmId: this.baseInfo.id
                }
            }).then(res => {
                this.$set(this.tabNums, 'intsnapshotNum', res ? res.length : 0)
            })
            // 获取任务
            this.axios.get(this.urlFormat(API.TASKS, true), {
                params: {
                    target: this.baseInfo.id
                }
            }).then(res => {
                this.$set(this.tabNums, 'taskNum', res ? res.length : 0)
            })
            // 获取告警
            this.axios.get(this.urlFormat(API.GET_MONDETAIL_ALARMS_INFO, true), {
                params: {
                    target: this.baseInfo.id
                }
            }).then(res => {
                this.$set(this.tabNums, 'alarmNum', res ? res.length : 0)
            })
            // 获取日志
            this.axios.get(this.urlFormat(API.GET_HOST_LOGS + `/${this.baseInfo.id}`, true)).then(res => {
                this.$set(this.tabNums, 'logNum', res ? res.length : 0)
            })
            // 获取历史
            this.axios.get(this.urlFormat(API.GET_ACTION_LOG, true), {
                params: {
                    resSid: this.baseInfo.id
                }
            }).then(res => {
                const r = res ? (res instanceof Array ? res.length : res.dataList.length) : 0
                this.$set(this.tabNums, 'historyStatus', r)
            })
            // 获取安全组
            this.axios.get(this.urlFormat(API.GET_SECURITY_GROUPS, true), {
                params: {
                    envId: this.baseInfo.cloudEnvId,
                    instanceId: this.baseInfo.id || ''
                }
            }).then(res => {
                const r = res ? (res instanceof Array ? res.length : res.dataList.length) : 0
                this.$set(this.tabNums, 'securityGroupNum', r)
            })
            // 获取脚本
            this.getAllScNum(API.GET_HOST_SCRIPT)
            // 获取参数配置
            this.axios.get(this.urlFormat(API.GET_HOST_PARAMCONFIG, true, [this.$route.params.id])).then(res => {
                this.$set(this.tabNums, 'paramConfigNum', res.length)
            })
        },
        async getAllScNum (urlApi) {
            const otherSc = await this.getAiax(urlApi, 'other')
            const decommissionSc = await this.getAiax(urlApi, 'decommission')
            const operationalSc = await this.getAiax(urlApi, 'operational')
            const bootSc = await this.getAiax(urlApi, 'boot')
            const stopSc = await this.getAiax(urlApi, 'stop')
            const arr = [].concat(otherSc, decommissionSc, operationalSc, bootSc, stopSc)
            this.$set(this.tabNums, 'scriptNum', arr.length)
        },
        getAiax (url, code) {
            return this.axios.get(this.urlFormat(url, true, [this.baseInfo.id, code]))
        },
        parseStatus () {
            return mgtConstant.parseHostStatus(this.baseInfo.status)
        },
        judgeCloudManageStatus () {
            return mgtConstant.judgeCloudManageStatus(this.baseInfo.manageStatus, this.baseInfo.status)
        },
        judgeInstanceStatusIcon () {
            return mgtConstant.judgeInstanceStatusIcon(this.baseInfo.manageStatus) + ' disabled'
        },
        // 重新纳管主机
        retryConnectHost () {
            this.$refs.accessInstance.openModal()
        },
        getPassword () {
            if (this.isPass) {
                if (this.baseInfo.managemenPassword && this.baseInfo.remoteLoginType !== 'ByKeypair') {
                    return this.baseInfo.managemenPassword
                } else {
                    if (this.baseInfo.remoteLoginType === 'ByKeypair') {
                        return this.baseInfo.keypairName
                    } else {
                        return '--'
                    }
                }
            } else if ((this.baseInfo.remoteLoginType === 'ByKeypair' && this.baseInfo.keypairName) || (this.baseInfo.remoteLoginType === 'ByPassword' && this.baseInfo.managemenPassword)) {
                return '******'
            } else {
                return '--'
            }
        },
        changeIsPassStatus () {
            this.isPass = !this.isPass
        },
        overviewClick (item) {
            if (item.tab && item.show) {
                this.$emit('update', item.tab)
            }
        },
        gotoMonitor () {
            this.$emit('update', 'basicmonitor')
        },
        getTagInfo () {
            const arr = []
            if (this.baseInfo.tagNames) {
                const colors = this.baseInfo.rgbCodes && this.baseInfo.rgbCodes.split(',')
                const tagValues = this.baseInfo.tagValues && this.baseInfo.tagValues.split(',')
                this.baseInfo.tagNames && this.baseInfo.tagNames.split(',').forEach((r, i) => {
                    const obj = { tagName: r, tagValue: tagValues ? tagValues[i] : '', rgbCode: colors[i] }
                    arr.push(obj)
                })
            }
            return arr
        },
        getConfigInfo () {
            const envType = this.baseInfo.cloudEnvType
            // const envId = this.baseInfo.cloudEnvId
            this.configData.forEach(cd => {
                (cd.children || []).forEach(item => {
                    if (['isG', 'network', 'tagNames'].indexOf(item.key) === -1) {
                        item.value = this.baseInfo[item.key]
                    }
                    if (item.key === 'tagNames') {
                        item.value = []
                        if (this.baseInfo.tagNames) {
                            const colors = this.baseInfo.rgbCodes && this.baseInfo.rgbCodes.split(',')
                            const tagValues = this.baseInfo.tagValues && this.baseInfo.tagValues.split(',')
                            this.baseInfo.tagNames && this.baseInfo.tagNames.split(',').forEach((r, i) => {
                                const obj = { tagName: r, tagValue: tagValues ? tagValues[i] : '', rgbCode: colors[i] }
                                item.value.push(obj)
                            })
                        }
                    }
                    if (item.key === 'zone') {
                        item.value = '--'
                        if (envType === 'VMware') {
                            item.value = this.baseInfo.zone
                            item.router = `/mgt/env/partition/${this.baseInfo.cloudEnvAccountId}?envType=` + this.baseInfo.cloudEnvType + '&envName=' + this.baseInfo.cloudEnvTypeName
                        } else {
                            item.value = this.baseInfo.zoneName
                            item.router = `/mgt/env/zone/${this.baseInfo.cloudEnvAccountId}?envType=` + this.baseInfo.cloudEnvType + '&envName=' + this.baseInfo.cloudEnvTypeName
                        }
                    }
                    if (item.key === 'network') {
                        // if (envType === 'VMware' && this.baseInfo.networkName) {
                        //     item.router = `/mgt/env/vpc/${envId}`
                        // } else {
                        //     item.router = ``
                        // }
                        item.value = this.baseInfo.cloudHostExt && this.baseInfo.cloudHostExt.subnet ? this.baseInfo.cloudHostExt.subnet : ''
                        // if (item.value) {
                        //     item.value.forEach(el => {
                        //         el.router = `/mgt/env/vpc/${el.resourceId}`
                        //     })
                        // }
                    }
                    if (item.key === 'serverTemplateName') {
                        item.router = `/mgt/template/detail/${this.baseInfo.serverTemplateId}`
                    }
                    // 前往资源组详情
                    // if (item.key === 'cloudDeploymentName') {
                    //     item.router = `/mgt/resgroup/detail/${this.baseInfo.cloudDeploymentId}`
                    // }
                    if (item.key === 'instanceChargeTypeName') {
                        if (this.baseInfo.instanceChargeTypeName) {
                            item.value = this.baseInfo.instanceChargeTypeName
                        } else if (envType === 'Aws') {
                            item.value = '按量计费'
                        } else {
                            item.value = '--'
                        }
                    }
                    if (item.key === 'securityGroupName') {
                        // item.value = this.baseInfo.securityGroupName || this.baseInfo.securityGroupId || '--'
                        item.value = (this.baseInfo.cloudHostExt && this.baseInfo.cloudHostExt.sg) ? this.baseInfo.cloudHostExt.sg : ''
                        // if (item.value) {
                        //     item.value.forEach(el => {
                        //         el.router = `/mgt/env/securitygroup/${el.resourceId}`
                        //     })
                        // }
                    }
                    if (item.key === 'endTime') {
                        if (this.baseInfo[item.key]) {
                            item.value = this.getDateStr(new Date(this.baseInfo[item.key]))
                        } else {
                            item.value = ''
                        }
                    }
                })
            })
            this.configData = JSON.parse(JSON.stringify(this.configData))
        },
        editConfigInfo () {
            // fixed bug 10543 （v3.4.0）创建中的主机编辑问题(创建中的主机不能编辑) by lcj
            if (this.isLocak || this.baseInfo.status === 'creating') {
                return
            }
            this.$refs.configInfoModal.openModal(this.baseInfo)
        },
        gotoDetail () {
            this.reload()
        },
        // 配置信息前往跳转
        goDetail (data) {
            if (data.value !== '--' && data.value && data.router && !this.isGoPer(data)) {
                const envType = this.baseInfo.cloudEnvType
                const envName = this.baseInfo.cloudEnvName
                this.$router.push({ path: data.router, query: { envType: envType, envName: envName } })
            }
        },
        isGoPer (data) {
            if (data.key === 'serverTemplateName') {
                if (this.hasPermission('MC01')) {
                    return false
                } else {
                    return true
                }
            } else if (data.key === 'cloudDeploymentName') {
                if (this.baseInfo.hasCloudDeploymentPer) {
                    return false
                } else {
                    return true
                }
            } else {
                return false
            }
        },
        reload () {
            this.$emit('update')
        },
        showBindWindow () {
            const id = this.baseInfo.id
            const tags = this.getSelectedTags(this.baseInfo)
            this.$refs.bindTags.open(id, tags, 'host')
        },
        // 获取当前row 已选tags
        getSelectedTags (row) {
            const tags = []
            const colors = row.rgbCodes ? row.rgbCodes.split(',') : []
            const tagValues = row.tagValues ? row.tagValues.split(',') : []
            row.tagNames && row.tagNames.split(',').forEach((r, i) => {
                const obj = { tagName: r, tagValue: tagValues ? tagValues[i] : '', rgbCode: colors[i] }
                tags.push(obj)
            })
            return tags
        },
        getDateStr (date) {
            return this.complement0(date.getFullYear()) + '-' +
                this.complement0(date.getMonth() + 1) + '-' +
                this.complement0(date.getDate()) + ' ' +
                this.complement0(date.getHours()) + ':' +
                this.complement0(date.getMinutes()) + ':' +
                this.complement0(date.getSeconds())
        },
        complement0 (num) {
            if (num < 10) {
                return '0' + num
            }
            return num
        },
        // editAralm () {
        //     this.$refs.instanceoper.init()
        // },
        refreshAlarm () {
            this.$refs.alarm.init()
        },
        // 复制剪切板
        copylink () {
            const copyrelay = this.$refs.copyrelay
            copyrelay[0].select()
            document.execCommand('Copy')
            this.$Message.success('资源ID已复制到剪切板')
        }
    }
}
</script>

<style lang="less">
.serverDetails {
    .disabledA {
        color: #ccc !important;
        cursor: not-allowed !important;
    }
}
</style>

<style lang="less" scoped>
.card {
    background: #fff;
    padding: 15px;
    border: 1px solid #e9e9e9;
    position: relative;
    .el-can-click {
        cursor: pointer;
        color: #333;
        margin-left: 5px;
    }
    .el-can-click:hover {
        text-decoration: underline;
    }
    .card-left {
        text-align: center;

        .icon-unlink-o {
            opacity: 0.6;
            cursor: not-allowed;
        }
        img {
            width: 63px;
            height: 52px;
            margin-bottom: 8px;
        }
        .status-btn {
            width: max-content;
            margin: 15px auto;
            border: 1px solid #e9e9e9;
            padding: 5px 15px 6px;
        }
    }
    .eye-i {
        cursor: pointer;
        display: inline-block;
        position: relative;
        top: 7px;
        transform: translateY(-50%);
    }
    .formItem {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-bottom: 10px;
        position: relative;
        font-size: 12px;
        color: #808080;
    }
    .overview-item {
        border-bottom: 1px dashed #e9e9e9;
        position: relative;
        &::after {
            content: '';
            display: inline-block;
            border-right: 1px dashed #e9e9e9;
            height: 30%;
            position: absolute;
            top: 35%;
            right: 0px;
        }
    }
    .overview-item:nth-of-type(5),
    .overview-item:nth-of-type(6),
    .overview-item:nth-of-type(7),
    .overview-item:nth-of-type(8) {
        border-bottom: none;
    }
    .overview-item:nth-of-type(4),
    .overview-item:last-child {
        &::after {
            border-right: none;
        }
    }
    .no-border-bottom {
        border-bottom: none;
    }
    .overview-card {
        height: 65.5px;
        font-size: 12px;
        display: flex;
        align-items: center;
        color: #333;
        padding-left: 20%;
        .left-icon {
            width: 40px;
            height: 40px;
            text-align: center;
            border: 1px solid #e9e9e9;
            border-radius: 50%;
            margin-right: 15px;
            cursor: pointer;
            i {
                font-size: 22px;
                position: relative;
                top: calc(~'50% - 13px');
            }
        }
        p {
            cursor: pointer;
            &:hover {
                color: #3366cc;
            }
        }
        p:last-child {
            margin-bottom: 0px;
        }
        .router-span {
            // color: #3366cc;
            // cursor: pointer;
            margin-left: 10px;
        }
        .btn-style {
            background: none;
            padding: 3px;
        }
        &.card-disabled {
            p {
                color: #e9e9e9;
                cursor: not-allowed;
            }
            .left-icon {
                cursor: not-allowed !important;
                i {
                    color: #e9e9e9 !important;
                }
            }
        }
    }
    .card-title {
        font-size: 12px;
        color: #333;
        font-weight: bold;
        height: 35px;
        line-height: 35px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title-icon {
            margin-right: 10px;
            cursor: pointer;
            color: #888888;
            font-size: 14px;
            margin-top: 11px;
        }
        .title-text {
            margin-right: 10px;
            cursor: pointer;
            color: #3366cc;
            font-weight: 500;
        }
    }
    .no-data {
        height: 180px;
        line-height: 180px;
        color: #ccc;
        font-size: 16px;
        text-align: center;
    }
    .card-pro {
        display: flex;
        justify-content: center;
        color: #ccc;
        .pro-container {
            margin: 0px 15px;
            text-align: center;
            p {
                margin: 5px 0px;
            }
        }
    }
    .config-tooltip {
        position: absolute;
        right: 15px;
        top: 17px;
        i {
            cursor: pointer;
            color: #999;
        }
    }
}
.col-title {
    display: inline-block;
    width: 90px;
    text-align: right;
    color: #999999;
    vertical-align: middle;
}
.col-content {
    margin-left: 12px;
    width: calc(~'100% - 115px');
    display: inline-block;
    vertical-align: middle;
    .router-span {
        // cursor: pointer;
        // color: #0099d7;
    }
    .copy-icon {
        font-size: 20px;
        cursor: pointer;
    }
}
.card-info-overview {
    .cio-top {
        display: flex;
        align-items: center;
        .col-title {
            img {
                height: 48px;
            }
        }
        > p {
            font-size: 14px;
            margin-left: 12px;
        }
        .status-btn {
            padding: 5px 15px;
            border-radius: 15px;
            background-color: #f5f6f7;
            margin-left: 12px;
            cursor: pointer;
            &:hover {
                .el-can-click {
                    text-decoration: underline;
                }
            }
        }
    }
    .cio-bottom {
        margin-top: 12px;
        .cio-dsc {
            margin-top: 6px;
            font-size: 12px;
            .tag-item {
                &:first-child {
                    margin-left: 0px !important;
                }
            }

            .icon-more-1-o {
                transform: rotate(90deg);
                color: #999;
                display: inline-block;
                cursor: pointer;
                display: block;
                height: 30px;
                width: 21px;
                margin-top: -3px;
                text-align: center;
                line-height: 30px;
            }
        }
    }
}
.config-item-title {
    color: #333;
    font-weight: bold;
    font-size: 12px;
}
.config {
    position: relative;
    .config-item {
        padding-bottom: 15px;
        .copy-el {
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
            z-index: -999;
        }
        .content {
            p {
                margin-top: 15px;
                font-size: 12px;
            }
        }
        &:last-child {
            padding-bottom: 0px;
        }
    }
}
.card-charts {
    height: 190px;
    padding: 0px 15px;
    .chart-item {
        padding: 0px 15px;
        height: 100%;
        .chart-content {
            height: 160px;
        }
        .tip {
            text-align: center;
            font-size: 12px;
            color: #ccc;
        }
    }
    .chart-item:hover {
        box-shadow: 0px 0px 10px 10px #f5f6f7;
    }
}
.rc-color-green {
    color: #2ecc71;
}
.pad-l-15 {
    padding-left: 15px;
}
.pad-t-15 {
    padding-top: 15px;
}
.mar-r15 {
    margin-right: 15px;
}
.mar-r10 {
    margin-right: 10px;
}
.mar-b15 {
    margin-bottom: 15px;
}
.mar-b10 {
    margin-bottom: 10px;
}
.height-180 {
    min-height: 180px;
}
.height-190 {
    height: 190px;
}
.groupWrap {
    margin-top: 5px;
    .textWrap {
        display: inline-block;
        max-width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .groupItem {
        .textVpcElli {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            max-width: 200px;
            display: inline-block;
        }
    }
}
</style>
